/**
 * Labstep
 *
 * @module components/Layout/GlobalSearch/Document
 * @desc Component to display individual search result
 */

import classNames from 'classnames';
import type { LayoutNewGlobalSearchDocumentProps } from 'labstep-web/components/Layout/NewGlobalSearch/Document/types';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import { Metadata } from 'labstep-web/models/metadata';
import { snakeCase } from 'lodash';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import styles from './styles.module.scss';

export const LayoutNewGlobalSearchDocument: React.FC<
  LayoutNewGlobalSearchDocumentProps
> = ({ result, onClick, isSelected = false }) => {
  return result.parent && !result.is_root ? (
    <Flex
      hAlignContent="left"
      vAlignContent="center"
      className={classNames(styles.documentItem, {
        [styles.selected]: isSelected,
      })}
      onClick={onClick}
      column
    >
      <Flex>
        <div>
          <Icon name={result.parent.icon} />
        </div>
        <div className={styles.documentName}>
          {result.parent.display_name}
        </div>
      </Flex>

      <Flex className={styles.secondaryInfo}>
        <Icon
          name={
            snakeCase(result.entity_class) === Metadata.entityName &&
            !['protocol_collection', 'experiment_workflow'].includes(
              snakeCase(result.parent.entity_class),
            )
              ? 'bookmark'
              : result.icon
          }
        />
        <div>{`${result.displayName}: ${result.data}`}</div>
      </Flex>
    </Flex>
  ) : (
    <Flex
      hAlignContent="left"
      vAlignContent="center"
      className={classNames(styles.documentItem, {
        [styles.selected]: isSelected,
      })}
      onClick={onClick}
    >
      <div>
        <Icon name={result.icon} />
      </div>
      <div className={styles.documentName}>{result.displayName}</div>
    </Flex>
  );
};

export default withRouter(LayoutNewGlobalSearchDocument);
